<template>
  <div class="items">
    <div class="items__manage">
      <div class="items__add-button">
        <vs-button icon="add" type="flat" @click="popupActive = true"
          >Add new supply</vs-button
        >
      </div>
    </div>

    <ItemsList
      @editItem="editItem($event)"
      @deleteItem="deleteItem($event)"
    />
    <vs-popup
      class="form-popup teachers__popup"
      classContent="teachers__popup-content"
      title="New teacher"
      :active.sync="popupActive"
    >
      <ItemsForm
        v-if="popupActive"
        :item="selectedItem"
        @closePopup="closePopup"
      />
    </vs-popup>
  </div>
</template>

<script>
import ItemsList from '@/components/items/itemsList.vue'
import ItemsForm from '@/components/items/itemsForm.vue'
import { mapState } from 'vuex'

export default {
  title: 'SE-Supplies',
  data() {
    return {
      popupActive: false,
      selectedItem: {},
      status: 1,
    }
  },
  computed: {
    ...mapState({
      items: state => state.items.items,
      singleItem: state => state.items.singleItem,
    }),
  },
  components: { ItemsList, ItemsForm },
  created() {
    this.getItems()
  },
  methods: {
    getItems: function() {
      let { status } = this
      this.$store
        .dispatch('items/getItemsAction', { status })
        .then(() => {})
    },
    editItem: function(id) {
      if (!id) {
        this.$vs.notify({
          title: 'Error',
          text: `Error open item`,
          color: 'danger',
          position: 'top-right',
        })
        this.selectedItem = {}
        return
      }
      this.$store
        .dispatch('items/getSingleItemAction', { id })
        .then(() => {
          this.selectedItem = this.singleItem
          this.popupActive = true
        })
    },
    deleteItem: function(id) {
      this.$store
        .dispatch('items/deleteItemsAction', id)
        .then(() => {
          this.selectedItem = {}
          this.popupActive = false
          this.$vs.notify({
            title: 'Removed',
            text: `Item removed`,
            color: 'success',
            position: 'top-right',
          })
        })
        .catch(r => {
          this.selectedItem = {}
          this.popupActive = false
          this.$vs.notify({
            title: 'Error',
            text: r.message,
            color: 'danger',
            position: 'top-right',
          })
        })
    },
    closePopup: function() {
      this.popupActive = false
      this.selectedItem = {}
      this.getItems()
    },
  },
}
</script>

<style lang="scss">
.vs-con-table header {
  min-height: 50px;
  padding: 5px 10px;
  border-radius: 10px;
  margin-bottom: 15px;
  background-color: #eee;
}
.vs-con-table {
  background-color: #fff;
  table {
    font-size: 1;
  }
}
.items {
  &__list {
    clear: both;
  }
  &__add-button {
    flex: 1;
    button {
      margin-bottom: 10px;
    }
  }
  &__manage {
    display: flex;
    flex-flow: row nowrap;
  }
  &__filter {
    display: flex;
    flex-flow: row nowrap;
    margin-left: 1.5rem;
    align-items: center;
    gap: 0.8rem;

    .con-select {
      margin: 0;
    }
  }
}
</style>
